import { useEffect } from 'react';
import { useActiveLocationsStore } from '@/stores/useActiveLocationsStore';

/**
 * Hook that refreshes a store when active locations change.
 * Uses a selector to create a stable string key for comparison.
 * 
 * @param store - The store with a refresh method
 */
export function useRefreshOnLocationChange(store: { refresh: () => void }) {
  // Use a selector to create a stable string key directly from the store
  // This ensures we only re-run when the actual values change, not references
  const locationIdsKey = useActiveLocationsStore(
    (state) => [...state.activeLocationIds].sort().join(',')
  );

  // Auto-refresh when active locations actually change
  useEffect(() => {
    store.refresh();
    // store is stable, no need to include in dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationIdsKey]);
}

